import { useState, useEffect } from "react";
import { Phone } from "lucide-react";

const LOGO = "https://customer-assets-v7afamib.emergentagent.net/job_deductible-to-done/artifacts/puragtdz_Copy%20of%20Herologo.PNG";

export default function Header() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollToQuote = () => {
    document.getElementById("quote")?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 inset-x-0 z-50 transition-[background-color,border-color,padding] duration-300 border-b ${
        scrolled
          ? "bg-hero-void/80 backdrop-blur-xl border-white/10 py-3"
          : "bg-transparent border-transparent py-5"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 flex items-center justify-between">
        <a href="/" data-testid="brand-logo" className="flex items-center gap-3">
          <img src={LOGO} alt="Hero Exteriors" className="h-11 w-auto rounded-md" />
        </a>

        <nav className="hidden md:flex items-center gap-9 text-sm font-medium text-hero-silver">
          <button onClick={() => document.getElementById("process")?.scrollIntoView({ behavior: "smooth" })} className="hover:text-white transition-colors duration-200" data-testid="nav-process">How It Works</button>
          <button onClick={() => document.getElementById("gallery")?.scrollIntoView({ behavior: "smooth" })} className="hover:text-white transition-colors duration-200" data-testid="nav-gallery">Our Work</button>
          <button onClick={scrollToQuote} className="hover:text-white transition-colors duration-200" data-testid="nav-quote">Free Inspection</button>
        </nav>

        <a
          href="tel:4432509046"
          data-testid="click-to-call-button"
          className="group inline-flex items-center gap-2 bg-hero-red hover:bg-hero-reddark text-white font-semibold text-sm px-5 py-2.5 rounded-md transition-colors duration-200"
        >
          <Phone className="h-4 w-4 group-hover:rotate-12 transition-transform duration-200" />
          <span className="hidden sm:inline">443-250-9046</span>
          <span className="sm:hidden">Call</span>
        </a>
      </div>
    </header>
  );
}
